import styled from 'styled-components';

export const SegmentedToggleStyled = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.colors.strokeA};
  border-radius: 5px;
  overflow: hidden;
`;

export const SegmentedToggleButton = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 9px 8px;
  border: none;
  background-color: ${({ active, theme }) => active ? theme.colors.black : theme.colors.white};
  color: ${({ active, theme }) => active ? theme.colors.white : theme.colors.textSecondary};
  font-family: ${({ active, theme }) => active ? theme.font.bold : theme.font.medium};
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  &:not(:first-child) {
    border-left: 1px solid ${({ theme }) => theme.colors.strokeA};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: -2px;
  }

  &:disabled {
    cursor: default;
  }
`;
